import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { apolloService } from '../../common/services'

import { REMOVE_FROM_ALLOCATION_MUTATION } from '../graphql/mutations'
import { REMOVE_FROM_ALLOCATION } from '../redux/action-types'

const useRemoveFromAllocationMutation = menuCurationTaskId => {
  const dispatch = useDispatch()

  const mutate = useCallback(
    () =>
      apolloService.mutate({
        mutation: REMOVE_FROM_ALLOCATION_MUTATION,
        variables: { id: menuCurationTaskId },
        dispatch,
        action: REMOVE_FROM_ALLOCATION,
      }),
    [menuCurationTaskId, dispatch],
  )

  return [mutate]
}

export default useRemoveFromAllocationMutation
